import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3115_7116)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 96C0 95.4477 0.447715 95 1 95H95C95.5523 95 96 95.4477 96 96H0Z",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.04749 8.76655C4.13069 6.6772 4.35962 5.29177 4.98953 4.14597C5.72087 2.81566 6.81564 1.72089 8.14595 0.989547C9.94593 0 12.3373 0 17.12 0H78.88C83.6627 0 86.054 0 87.854 0.989547C89.1843 1.72089 90.2791 2.81566 91.0104 4.14597C91.6403 5.29175 91.8693 6.67715 91.9525 8.76643C91.3413 8.05983 90.608 7.46228 89.7832 7.00464C87.9726 6 85.5547 6 80.7191 6H15.281C10.4453 6 8.02749 6 6.21683 7.00464C5.39197 7.46231 4.6587 8.0599 4.04749 8.76655ZM38 3C38 2.44772 38.4477 2 39 2H41C41.5523 2 42 2.44772 42 3C42 3.55228 41.5523 4 41 4H39C38.4477 4 38 3.55228 38 3ZM46 3C46 2.44772 46.4477 2 47 2H49C49.5523 2 50 2.44772 50 3C50 3.55228 49.5523 4 49 4H47C46.4477 4 46 3.55228 46 3ZM55 2C54.4477 2 54 2.44772 54 3C54 3.55228 54.4477 4 55 4H57C57.5523 4 58 3.55228 58 3C58 2.44772 57.5523 2 57 2H55Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M80.7191 7H15.281C12.8454 7 11.0833 7.00089 9.70172 7.12177C8.33295 7.24154 7.43353 7.47318 6.70202 7.87906C5.53136 8.5286 4.57152 9.50021 3.93631 10.6787C3.53938 11.4151 3.31872 12.3173 3.21566 13.6874C3.11163 15.0703 3.13223 16.8324 3.16193 19.2678L3.84193 75.0278C3.87098 77.4103 3.89287 79.1333 4.02657 80.4848C4.15899 81.8234 4.39429 82.7045 4.79711 83.423C5.44156 84.5726 6.39743 85.5169 7.55477 86.1473C8.27818 86.5413 9.16211 86.7658 10.5022 86.8819C11.8552 86.9991 13.5784 87 15.961 87H80.0391C82.4217 87 84.1449 86.9991 85.4979 86.8819C86.838 86.7658 87.7219 86.5413 88.4453 86.1473C89.6027 85.5169 90.5585 84.5726 91.203 83.423C91.6058 82.7045 91.8411 81.8234 91.9735 80.4848C92.1072 79.1333 92.1291 77.4103 92.1582 75.0278L92.8382 19.2678C92.8679 16.8324 92.8885 15.0703 92.7844 13.6874C92.6814 12.3173 92.4607 11.4151 92.0638 10.6787C91.4286 9.50021 90.4687 8.5286 89.2981 7.87906C88.5666 7.47318 87.6672 7.24154 86.2984 7.12177C84.9168 7.00089 83.1547 7 80.7191 7ZM3.05603 10.2042C2.07355 12.027 2.10303 14.4447 2.162 19.28L2.842 75.04C2.89968 79.7699 2.92852 82.1348 3.92483 83.912C4.66134 85.2258 5.75377 86.305 7.07644 87.0254C8.86566 88 11.2308 88 15.961 88H80.0391C84.7693 88 87.1344 88 88.9237 87.0254C90.2463 86.305 91.3388 85.2258 92.0753 83.912C93.0716 82.1348 93.1004 79.7699 93.1581 75.04L93.8381 19.28C93.8971 14.4447 93.9266 12.027 92.9441 10.2042C92.2181 8.85739 91.1211 7.74697 89.7833 7.00464C87.9726 6 85.5548 6 80.7191 6H15.281C10.4453 6 8.02751 6 6.21685 7.00464C4.87895 7.74697 3.78199 8.85739 3.05603 10.2042Z",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28 36H39.5",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28 56H54",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27 76H38",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.1366 17.6394C41.6366 15.806 42.2366 12.6394 48.6366 14.6394C56.6366 17.1394 45.1365 18.6394 47.1365 17.1393C49.1365 15.6393 54.1365 14.6392 59.1365 15.6392",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 54,
				r: 5.5,
				stroke: "white",
				strokeOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16.3457,
				y: 40.0935,
				width: 1,
				height: 2,
				rx: .5,
				transform: "rotate(-9.25773 16.3457 40.0935)",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 17.0479,
				y: 43.8829,
				width: 1,
				height: 2,
				rx: .5,
				transform: "rotate(29.015 17.0479 43.8829)",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16.7269,
				y: 61.9158,
				width: 1,
				height: 2,
				rx: .5,
				transform: "rotate(12.4267 16.7269 61.9158)",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 16.2527,
				y: 66.1685,
				width: 1,
				height: 2,
				rx: .5,
				transform: "rotate(-15.3808 16.2527 66.1685)",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M17 38C20.3137 38 23 35.3137 23 32C23 30.5443 22.4816 29.2096 21.6192 28.1706C21.598 28.2084 21.572 28.2452 21.5412 28.2799L17.0212 33.371C16.2229 34.2702 14.8622 34.2031 14.4989 33.2465L13.3364 30.1851C13.2462 29.9475 13.3884 29.6482 13.6542 29.5166C13.9199 29.3849 14.2084 29.4707 14.2987 29.7082L15.4612 32.7697C15.5823 33.0885 16.0359 33.1109 16.302 32.8112L20.8219 27.7201C20.884 27.6502 20.9581 27.5967 21.0368 27.561C19.971 26.5912 18.5545 26 17 26C13.6863 26 11 28.6863 11 32C11 35.3137 13.6863 38 17 38Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.186 31.6397C27.6565 29.8415 29.0821 25.9468 35.5 27.5C43.5224 29.4416 33.6561 33.2182 33.1653 30.7909C32.5 27.5 45.5 31.6397 61 29.0001",
				stroke: "white",
				strokeOpacity: .48,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.7931 51.2735C27.5417 51.3878 27.4305 51.6842 27.5448 51.9356C27.6591 52.187 27.9555 52.2982 28.2069 52.1839L27.7931 51.2735ZM36 50.2287L35.6204 49.9033L36 50.2287ZM28.2069 52.1839C30.0351 51.3529 32.6067 50.291 34.4101 49.7851C34.8594 49.659 35.2481 49.5713 35.5582 49.5288C35.8892 49.4834 36.0586 49.5007 36.1154 49.5202C36.1322 49.526 36.0811 49.5126 36.0391 49.443C35.9947 49.3695 36.0075 49.3121 36.0053 49.3231C35.9941 49.3797 35.9142 49.5605 35.6204 49.9033L36.3796 50.5541C36.6858 50.1969 36.9205 49.8475 36.9861 49.5186C37.0223 49.3369 37.0141 49.1231 36.8952 48.9262C36.7787 48.7331 36.5996 48.6293 36.4409 48.5747C36.1466 48.4734 35.7748 48.4897 35.4223 48.538C35.0488 48.5892 34.6114 48.69 34.1399 48.8223C32.26 49.3497 29.6315 50.4379 27.7931 51.2735L28.2069 52.1839ZM35.6204 49.9033C34.2415 51.512 32.5437 51.7103 31.8885 51.6095C31.8108 51.5975 31.7625 51.5834 31.7395 51.5746C31.7006 51.5596 31.7567 51.5708 31.8171 51.6472C31.8539 51.6937 31.9019 51.7783 31.9057 51.8948C31.9095 52.0145 31.8648 52.1079 31.8221 52.1647C31.7547 52.2543 31.6868 52.265 31.7392 52.2462C31.8174 52.2181 32.0186 52.1771 32.401 52.1639C32.7719 52.1512 33.2815 52.1654 33.9547 52.2266L34.0453 51.2308C33.3435 51.167 32.7906 51.1499 32.3666 51.1645C31.954 51.1787 31.628 51.2236 31.4014 51.305C31.3015 51.3408 31.1369 51.412 31.0229 51.5637C30.9568 51.6515 30.9013 51.7762 30.9062 51.9271C30.911 52.0748 30.9718 52.1904 31.0325 52.2672C31.1407 52.4041 31.2892 52.4729 31.3813 52.5082C31.4894 52.5497 31.611 52.5786 31.7365 52.5979C32.7063 52.7471 34.7585 52.4454 36.3796 50.5541L35.6204 49.9033ZM33.9547 52.2266C36.7519 52.481 39.2909 52.2956 41.1294 52.0474C42.0494 51.9232 42.796 51.783 43.3144 51.6734C43.5736 51.6185 43.7759 51.5714 43.9143 51.5376C43.9836 51.5207 44.0369 51.5072 44.0734 51.4977C44.0917 51.493 44.1057 51.4893 44.1155 51.4867C44.1203 51.4854 44.1241 51.4844 44.1269 51.4837C44.1282 51.4833 44.1293 51.483 44.1301 51.4828C44.1305 51.4827 44.1308 51.4826 44.1311 51.4825C44.1312 51.4825 44.1314 51.4824 44.1315 51.4824C44.1316 51.4824 44.1317 51.4823 44 51C43.8683 50.5177 43.8684 50.5176 43.8684 50.5176C43.8684 50.5176 43.8685 50.5176 43.8685 50.5176C43.8685 50.5176 43.8684 50.5176 43.8683 50.5177C43.868 50.5177 43.8674 50.5179 43.8666 50.5181C43.8649 50.5186 43.8622 50.5193 43.8584 50.5203C43.8508 50.5223 43.8389 50.5255 43.8228 50.5296C43.7907 50.5379 43.742 50.5503 43.6775 50.5661C43.5483 50.5975 43.3561 50.6424 43.1075 50.695C42.6102 50.8002 41.8881 50.9359 40.9956 51.0564C39.2091 51.2975 36.7481 51.4765 34.0453 51.2308L33.9547 52.2266Z",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M94.571 92.4667C94.571 91.1044 93.4667 90 92.1044 90H89.6377V94.9333H88.1418V90H66.8835C63.4493 90 60.0036 90.6924 56.8288 92.002C56.5171 92.1306 56.5015 92.5724 56.8083 92.7122C60.0201 94.1759 63.5086 94.9333 67.0382 94.9333H92.1044C93.4667 94.9333 94.571 93.829 94.571 92.4667Z",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.6933 70.3803L19.2027 69.7466C19.5091 69.7035 19.7027 69.6768 19.8409 69.6707C19.8493 69.6703 19.8572 69.6705 19.8645 69.6703C19.8611 69.6772 19.859 69.6856 19.8549 69.6934C19.7906 69.8158 19.6837 69.9794 19.5144 70.2383L17.9867 72.5742C17.9188 72.678 17.8519 72.7813 17.8019 72.8733C17.7487 72.9714 17.695 73.0912 17.6775 73.237C17.6569 73.4091 17.6815 73.5839 17.7487 73.7437C17.8057 73.879 17.8904 73.9793 17.9686 74.0589C18.0419 74.1336 18.1348 74.2145 18.2286 74.2956L20.341 76.1199C20.5751 76.3221 20.723 76.4499 20.8185 76.5498C20.8244 76.556 20.829 76.5629 20.834 76.5684C20.8269 76.5702 20.8195 76.5735 20.8113 76.5755C20.6768 76.6077 20.4833 76.6354 20.1769 76.6785L14.5389 77.4708L13.7233 71.6675C13.6805 71.363 13.6534 71.1659 13.6454 71.0148C13.6378 70.8702 13.651 70.8146 13.6617 70.7867C13.6953 70.6981 13.7537 70.6207 13.8296 70.5639C13.8535 70.5459 13.9033 70.5179 14.0444 70.4853C14.1919 70.4514 14.3887 70.4231 14.6933 70.3803Z",
				stroke: "white",
				strokeOpacity: .48
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.1134 78.0355L15.1037 77.8963L15.5908 81.3623C15.6292 81.6357 15.4387 81.8886 15.1652 81.927C14.8918 81.9654 14.6389 81.7749 14.6005 81.5015L14.1134 78.0355Z",
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 4,
				cy: 94,
				r: 1,
				fill: "white",
				fillOpacity: .48
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 7,
				cy: 93,
				r: 2,
				fill: "white",
				fillOpacity: .48
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3115_7116",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgProgressDark;
